const selectors = {
  getLocations: state => state.locations.get('allLocations')
};

export default selectors;
